<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :options="settings.dropdownOptions" ref="input" :disabled="disabled ? true : null" :tabindex="tabindex"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import categorySelector from '~/views/floating-centers/category-selector'

	export default {
		props: {
			modelValue: {},
			options: {},
			tabindex: {},
			disabled: { type: Boolean, default: false }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					type: null,
					dropdownOptions: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						searchableFields: ['name'],
						findExactMatch: this.findExactMatch,
						buttons: [{
							title: this.$t('category.category-modify'),
							shortcut: $sc.find('enter'),
							isPrimary: true,
							element: () => { return this.$el },
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showCategories()
							}
						}],
						display: (item) => `${item.code} - ${item.name}`
					}
				},
				localValue: null
			}
		},
		computed: {
			...mapGetters({
				category_all: 'floatingCenterCategories/all',
				category_type: 'floatingCenterCategories/allInType'
			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)
					this.localValue = val
				}
			},
			dropdownData() {
				if (this.settings.type == null) {
					return this.category_all
				} else {
					return this.category_type(this.settings.type)
				}
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.extend({}, this.settings, val)
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {

		},
		methods: {
			showCategories() {
				this.showModal({ component: categorySelector, data: null, options: { type: this.settings.type, selectable: this.settings.selectable } })
					.then(result => {
						this.dropdownValue = result
						this.$refs.input.focusAndSelect()
					}).catch(() => { })
			}
		},
	}
</script>
<style></style>
